import { render } from "./InterviewResults.vue?vue&type=template&id=61b7b15c&scoped=true"
import script from "./InterviewResults.vue?vue&type=script&lang=js"
export * from "./InterviewResults.vue?vue&type=script&lang=js"

import "./InterviewResults.vue?vue&type=style&index=0&id=61b7b15c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b7b15c"]])

export default __exports__